/**
 * Team Configuration Registry — dashboard instance defaults
 */

import { creightonConfig } from './creighton';

export const SPORT_CODES = {
  MBB: 'MBB',   // Men's College Basketball
  WBB: 'WBB',   // Women's College Basketball
};

export const SPORT_CATEGORIES = {
  basketball: ['MBB', 'WBB'],
};

export const teamRegistry = {
  creighton: creightonConfig,
};

function getDefaultTeamId() {
  if (typeof process !== 'undefined' && process.env?.REACT_APP_TEAM_ID) {
    return process.env.REACT_APP_TEAM_ID;
  }
  return 'creighton';
}

export const defaultTeamId = getDefaultTeamId();
export const defaultConfig = teamRegistry[defaultTeamId] || creightonConfig;

export function getTeamConfig(teamId) {
  return teamRegistry[teamId] || defaultConfig;
}

export function getAvailableTeams() {
  return Object.keys(teamRegistry);
}

export function teamExists(teamId) {
  return teamId in teamRegistry;
}

export function getBasketballTeams() {
  return Object.entries(teamRegistry)
    .filter(([, config]) => SPORT_CATEGORIES.basketball.includes(config.sportCode))
    .map(([teamId]) => teamId);
}

// Convenience re-exports
export { creightonConfig };
// Aliases for backward compat with design-system primitives
export const slamConfig = creightonConfig;
export const slamballConfig = creightonConfig;
